<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('privacy') }}
    </h1>
     <span v-if="country_name_fplus == 'greece' && gateway_code =='mobivas'">
     
        <privacy-paydash-greek/>
     
    </span>
     <span v-else>
      
      <span v-if="lang_fplus == 'arabic'">
        <privacy-arabic/>
      </span>
      <span v-else-if="lang_fplus == 'malay'">
      </span>
      <span v-else-if="lang_fplus == 'greek'">
        <privacy-greek/>
      </span>
      <span v-else-if="lang_fplus == 'czech'">
        <privacy-czech/>
      </span>
      <span v-else-if="lang_fplus == 'bulgarian'">
        <privacy-bulgarian/>
      </span>
      <span v-else-if="lang_fplus == 'norwegian'">
        <privacy-norwegian/>
      </span>

      <span v-else>
        <privacy-english/>
      </span>
    </span>
    
  </div>
</template>

<script>
import PrivacyPolicyEnglish from './../PrivacyPolicyEnglish';
import PrivacyPolicyArabic from './../PrivacyPolicyArabic';
import PrivacyPolicyMalay from './../PrivacyPolicyMalay';
import PrivacyPolicyGreek from './../PrivacyPolicyGreek';
import PrivacyPolicyCzech from './../PrivacyPolicyCzech';
import PrivacyPolicyPaydashGreek from './PrivacyPolicyPaydashGreek';
import PrivacyPolicyPaydashEnglish from './PrivacyPolicyPaydashEnglish';
import PrivacyPolicyBulgarian from './../PrivacyPolicyBulgarian';
import PrivacyPolicyNorwegian from './../PrivacyPolicyNorwegian';
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_fplus", "country_fplus","gateway_code","country_name_fplus"]),
  components:{
    'privacy-english': PrivacyPolicyEnglish,
    'privacy-arabic': PrivacyPolicyArabic,
    'privacy-malay': PrivacyPolicyMalay,
    'privacy-greek': PrivacyPolicyGreek,
    'privacy-czech': PrivacyPolicyCzech,
    'privacy-paydash-greek' :PrivacyPolicyPaydashGreek,
    'privacy-paydash-english':PrivacyPolicyPaydashEnglish,
    'privacy-bulgarian': PrivacyPolicyBulgarian,
    'privacy-norwegian': PrivacyPolicyNorwegian
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}
.mobitxt a {
    
    color: black !important;
}
</style>


// WEBPACK FOOTER //
// src/components/funplus/PrivacyPolicy.vue